import { createColumnHelper } from '@tanstack/react-table';
import type { Collaborator } from '@/features/Collaborators/Models';
import {
  resolveSummaryBalance,
  resolveSummaryConcessivePeriod,
  resolveSummaryEntitledFrom,
  resolveSummarySituation,
} from '@/features/Vacations/utils/vacationSummaryColumns';
import { VacationSummaryCell } from './VacationSummaryCell';

const columnHelper = createColumnHelper<Collaborator>();

export function buildVacationColumns(today = new Date()) {
  return [
    columnHelper.accessor(
      (row) => resolveSummaryBalance(row.vacationSummary, today).sortValue,
      {
        id: 'vacationBalance',
        header: 'SALDO DE DIAS',
        cell: ({ row }) => {
          const summary = row.original.vacationSummary;
          const { display, caption, tone } = resolveSummaryBalance(summary, today);
          return <VacationSummaryCell display={display} caption={caption} tone={tone} />;
        },
        sortUndefined: 'last',
      }
    ),

    columnHelper.accessor(
      (row) => resolveSummaryEntitledFrom(row.vacationSummary, today).sortValue?.getTime(),
      {
        id: 'vacationEntitledFrom',
        header: 'DIREITO A PARTIR DE',
        cell: ({ row }) => {
          const summary = row.original.vacationSummary;
          const { display, caption, tone } = resolveSummaryEntitledFrom(summary, today);
          return <VacationSummaryCell display={display} caption={caption} tone={tone} />;
        },
        sortUndefined: 'last',
      }
    ),

    columnHelper.display({
      id: 'vacationConcessivePeriod',
      header: 'LIMITE PARA AGENDAR',
      cell: ({ row }) => {
        const summary = row.original.vacationSummary;
        const { display, caption, tone } = resolveSummaryConcessivePeriod(summary, today);
        return <VacationSummaryCell display={display} caption={caption} tone={tone} />;
      },
      enableSorting: false,
    }),

    columnHelper.display({
      id: 'vacationSituation',
      header: 'SITUAÇÃO',
      cell: ({ row }) => {
        const summary = row.original.vacationSummary;
        const { display, caption, tone } = resolveSummarySituation(summary, today);
        return <VacationSummaryCell display={display} caption={caption} tone={tone} />;
      },
      enableSorting: false,
    }),
  ];
}
